import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { FormControl } from 'react-bootstrap'

import PopupTypes from '../../popup_types'
import {
  GlgPopup,
  GlgPopupForm,
  GlgCheckbox,
} from 'SharedComponents'

class CloneEventCopyOptionsPopup extends Component {
  constructor(props) {
    super(props)
    this.onClose = props.onClose.bind(this, PopupTypes.CLONE_EVENT_COPY_OPTIONS)
    this.onSave = this.onSave.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSelectAll = this.handleSelectAll.bind(this)
    this.handleUnselectAll = this.handleUnselectAll.bind(this)
    this.state = {
      copyManagers: true,
      copyPlayerRoster: false,
      copyLogos: true,
      copyAllPortalPages: true,
      openRegistration: true,
      openRegistrationDisabled: true,
      tournaments: true,
      tournamentLibrary: true,
      golfHubPage: true,
      copyDft: true,
      copyDftDisabled: true,
      roundsAndSeries: true,
      roundsAndSeriesDisabled: true,
      stripeAccount: true,
      registrationPaymentOptions: true,
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.show !== nextProps.show ||
           this.state !== nextState
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      const needDftAndRounds = this.state.tournaments || this.props.data.isExpressEvent
      this.isNonGolfEvent = this.props.data.fromProduct === 'non-golf-event' 
      this.setState({
        copyManagers: this.props.data && this.props.data.managers && this.props.data.managers.length > 0,
        openRegistration: this.props.data.hasOpenRegistration || this.props.data.copyStripeAndFees,
        openRegistrationDisabled: this.props.data.copyStripeAndFees,
        stripeAccount: this.props.data.stripeAccount,
        registrationPaymentOptions: this.props.data.copyStripeAndFees || this.props.data.golfHubRegistration,
        copyDft: needDftAndRounds,
        copyDftDisabled: needDftAndRounds,
        roundsAndSeries: needDftAndRounds,
        roundsAndSeriesDisabled: needDftAndRounds,
        golfHubPage: this.props.data.golfHubPage
      })
    }
  }

  handleChange(key, value) {
    const updates = {
      [key]: value,
    }
    if (key === 'tournaments') {
      if (value) { // checked
        updates.copyDftDisabled = true
        updates.roundsAndSeriesDisabled = true
        updates.copyDft = true
        updates.roundsAndSeries = true
      } else {
        if (!this.props.data.isExpressEvent) {
          updates.copyDftDisabled = false
          updates.roundsAndSeriesDisabled = false
        }
      }
    } else if (key === 'registrationPaymentOptions') {
      if (value) { // checked
        updates.openRegistration = true
        updates.openRegistrationDisabled = true
      } else {
        updates.openRegistrationDisabled = false
      }
    }
    this.setState(updates)
  }

  buildCopyOptions() {
    const options = []
    if (this.state.copyManagers) { options.push('copy_managers') }
    if (this.state.copyPlayerRoster) { options.push('copy_player_roster') }
    if (this.state.copyLogos) { options.push('copy_logos') }
    if (this.state.copyAllPortalPages) { options.push('copy_all_portal_pages') }
    if (this.state.openRegistration) { options.push('open_registration') }
    if (this.state.tournaments) { options.push('tournaments') }
    if (this.state.tournamentLibrary) { options.push('tournament_library') }
    if (this.state.golfHubPage) { options.push('golf_hub_page') }
    if (this.state.copyDft) { options.push('copy_dft') }
    if (this.state.roundsAndSeries) { options.push('rounds_and_series') }
    if (this.state.stripeAccount) { options.push('stripe_account') }
    if (this.state.registrationPaymentOptions) { options.push('registration_payment_options') }
    return options
  }

  onSave() {
    if (!this.shouldSkipCalendarPopup()) {
      this.props.onSave({
        copyOptions: this.buildCopyOptions(),
        ...this.props.data,
      })
    }
  }

  // We skip calendar popup when there are no rounds
  shouldSkipCalendarPopup() {
    return this.props.data && (this.props.data.roundsCount === 0 || !this.state.roundsAndSeries)
  }

  getFormURL() {
    if (this.shouldSkipCalendarPopup()) {
      // Set form url to skip calendar popup when submitting
      return this.props.formURL
    } else {
      return null
    }
  }

  getSaveButtonText() {
    if (this.shouldSkipCalendarPopup()) {
      return 'Clone'
    } else {
      return 'Next'
    }
  }

  handleSelectAll() {
    const checkboxStates = _.mapValues(this.state, () => true)
    this.setState(checkboxStates)
  }

  handleUnselectAll() {
    let checkboxStates = _.mapValues(this.state, () => false)
    if (this.props.data.isExpressEvent) {
      checkboxStates = {
        ...checkboxStates,
        copyDft: true,
        copyDftDisabled: true,
        roundsAndSeries: true,
        roundsAndSeriesDisabled: true,
      }
    }
    this.setState(checkboxStates)
  }

  getManagersTooltip() {
    return this.props.data.managers.map(manager => (
      `${ manager.name } (${ manager.email })`
    )).join('\n')
  }

  render() {
    return (
      <GlgPopup title="Select content to be cloned"
                show={ this.props.show }
                saveButtonText={ this.getSaveButtonText() }
                closeButtonText="Cancel"
                formURL={ this.getFormURL() }
                onClose={ this.onClose }
                onSave={ this.onSave }
                modalClass="clone-event-copy-options">
        <GlgPopupForm>
          {this.props.data.fromLeague && (
            <Fragment>
              <FormControl type="hidden" name="league_id" value={ this.props.data.fromLeague } />
              <FormControl type="hidden" name="product" value={ this.props.data.fromProduct } />
              <FormControl type="hidden" name="name" value={ this.props.data.leagueName } />
              <FormControl type="hidden" name="category" value={ this.props.data.category } />
              <FormControl type="hidden" name="season" value={ this.props.data.season } />
              <FormControl type="hidden" name="tour" value={ this.props.data.tour } />
              <FormControl type="hidden" name="is_express_event" value={ this.props.data.isExpressEvent } />
              <FormControl type="hidden" name="payment_model" value={ this.props.data.paymentModel } />
              <FormControl type="hidden" name="mass_dates" value="" />
            </Fragment>
          )}

          {this.props.data && this.props.data.managers && this.props.data.managers.length > 0 && (
            <GlgCheckbox name="copy_options[]"
                         value="copy_managers"
                         label="Managers"
                         checked={ this.state.copyManagers }
                         onChange={ (val) => this.handleChange('copyManagers', val) }
                         tooltip={ this.getManagersTooltip() } />
          )}
          <GlgCheckbox name="copy_options[]"
                       value="copy_player_roster"
                       label={ this.isNonGolfEvent ? "Participants" : "Player Roster" }
                       checked={ this.state.copyPlayerRoster }
                       onChange={ (val) => this.handleChange('copyPlayerRoster', val) } />
          <GlgCheckbox name="copy_options[]"
                       value="copy_logos"
                       label="Logos and Banners"
                       checked={ this.state.copyLogos }
                       onChange={ (val) => this.handleChange('copyLogos', val) }
                       tooltip="If unchecked, we will copy the logos and banners from the default website logos and banners (Customer Settings > Logos, Banners & Backgrounds)." />
          <GlgCheckbox name="copy_options[]"
                       value="copy_all_portal_pages"
                       label="Member Portal"
                       checked={ this.state.copyAllPortalPages }
                       onChange={ (val) => this.handleChange('copyAllPortalPages', val) }
                       tooltip="If unchecked, we will copy from the default member portal (Customer Settings > Default League / Event Member Portal)" />
          {this.props.data.hasOpenRegistration && (
            <GlgCheckbox name="copy_options[]"
                         value="open_registration"
                         label="Registration Form"
                         checked={ this.state.openRegistration }
                         disabled={ this.state.openRegistrationDisabled }
                         onChange={ (val) => this.handleChange('openRegistration', val) } />
          )}
          {!this.isNonGolfEvent && (
            <GlgCheckbox name="copy_options[]"
                         value="tournaments"
                         label="Tournaments"
                         checked={ this.state.tournaments }
                         onChange={ (val) => this.handleChange('tournaments', val) }
                         tooltip="Cloning Tournaments requires cloning 'Event Divisions / Flights / Teams' and 'Rounds & Series'" />
          )}
          {!this.isNonGolfEvent && (
            <GlgCheckbox name="copy_options[]"
                         value="tournament_library"
                         label="Tournament Library"
                         checked={ this.state.tournamentLibrary }
                         onChange={ (val) => this.handleChange('tournamentLibrary', val) } />
          )}
          {this.props.data.golfHubPage && (
            <GlgCheckbox name="copy_options[]"
                         value="golf_hub_page"
                         label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.clone_event_copy_options_popup.gh_page' )}
                         checked={ this.state.golfHubPage }
                         onChange={ (val) => this.handleChange('golfHubPage', val) } />
          )}
          <GlgCheckbox name="copy_options[]"
                       value="copy_dft"
                       label={ this.isNonGolfEvent ? "Event Divisions / Teams" : "Event Divisions / Flights / Teams" }
                       checked={ this.state.copyDft }
                       disabled={ this.state.copyDftDisabled }
                       onChange={ (val) => this.handleChange('copyDft', val) } />
          <GlgCheckbox name="copy_options[]"
                       value="rounds_and_series"
                       label={
                        this.isNonGolfEvent ? (
                          <>Dates & Series</> 
                        ) : (
                          <>Rounds & Series</>
                        )
                       }
                       checked={ this.state.roundsAndSeries }
                       disabled={ this.state.roundsAndSeriesDisabled }
                       onChange={ (val) => this.handleChange('roundsAndSeries', val) } />
          {this.props.data.stripeAccount && (
            <GlgCheckbox name="copy_options[]"
                         value="stripe_account"
                         label="Payment Gateway"
                         checked={ this.state.stripeAccount }
                         onChange={ (val) => this.handleChange('stripeAccount', val) } />
          )}
          {(this.props.data.copyStripeAndFees || this.props.data.golfHubRegistration) && (
            <GlgCheckbox name="copy_options[]"
                         value="registration_payment_options"
                         label="Registration Payment Options"
                         checked={ this.state.registrationPaymentOptions }
                         onChange={ (val) => this.handleChange('registrationPaymentOptions', val) } />
          )}
          <div className='buttons add-margin-bottom-10'>
            <a onClick={ this.handleSelectAll } className="clickable">
              Check All
            </a>
            <span>
              { ' / ' }
            </span>
            <a onClick={ this.handleUnselectAll } className="clickable">
              Uncheck All
            </a>
          </div>
        </GlgPopupForm>
      </GlgPopup>
    )
  }
}

CloneEventCopyOptionsPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  data: PropTypes.object,
  formURL: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
}

export default CloneEventCopyOptionsPopup
